/**
 * Cross-app links between the brand and admin dashboards. Both render nothing
 * when `href` is null: visibility is config-driven (the other app's origin is
 * set per environment) and fails closed. Plain anchors, not router links: the
 * target is another origin, opened in the same tab.
 */
import { ArrowSquareOut } from '../../design-system/icons';
import { TOP_BAR_PILL_CLASS } from './topBarPill';

export interface AppSwitchProps {
  /** The other app's origin, or null when it is not configured. */
  href: string | null;
  label: string;
}

/** Login-footer line: "<prefix> <link>" under the existing CTA lines. */
export function AppSwitchLine({ href, label, prefix }: AppSwitchProps & { prefix: string }) {
  if (!href) return null;
  return (
    <p className="text-center text-body-sm-regular text-foreground">
      {prefix}{' '}
      <a href={href} className="text-body-sm-medium text-(--brand-500) hover:underline">
        {label}
      </a>
    </p>
  );
}

/** Top-bar pill button; icon-only below `sm`, like the draft-status badge. */
export function AppSwitchButton({ href, label }: AppSwitchProps) {
  if (!href) return null;
  return (
    <a href={href} className={`${TOP_BAR_PILL_CLASS} transition-colors hover:bg-muted`}>
      <ArrowSquareOut size={16} aria-hidden="true" />
      <span className="max-sm:sr-only">{label}</span>
    </a>
  );
}
